import { useEffect, useRef, useState } from "react";
import {
	IoMdArrowDropleft,
	IoMdArrowDropright,
	IoMdArrowDropup,
	IoMdArrowDropdown,
} from "react-icons/io";

const ScrollableWrapper = ({
	children,
	direction = "horizontal",
	scrollAmount = 100,
	className = "",
}) => {
	const containerRef = useRef(null);
	const [canScrollBack, setCanScrollBack] = useState(false);
	const [canScrollForward, setCanScrollForward] = useState(false);

	const isHorizontal = direction === "horizontal";

	const checkScroll = () => {
		const el = containerRef.current;
		if (!el) return;

		if (isHorizontal) {
			setCanScrollBack(el.scrollLeft > 0);
			setCanScrollForward(el.scrollLeft + el.clientWidth < el.scrollWidth);
		} else {
			setCanScrollBack(el.scrollTop > 0);
			setCanScrollForward(el.scrollTop + el.clientHeight < el.scrollHeight);
		}
	};

	useEffect(() => {
		checkScroll();
		const el = containerRef.current;
		if (!el) return;

		el.addEventListener("scroll", checkScroll);
		window.addEventListener("resize", checkScroll);

		return () => {
			el.removeEventListener("scroll", checkScroll);
			window.removeEventListener("resize", checkScroll);
		};
	}, []);

	const scroll = (amount) => {
		const el = containerRef.current;
		if (!el) return;

		if (isHorizontal) {
			el.scrollBy({ left: amount, behavior: "smooth" });
		} else {
			el.scrollBy({ top: amount, behavior: "smooth" });
		}
	};

	return (
		<div
			ref={containerRef}
			className={` w-full h-full ${className} overflow-scroll`}
		>
			{canScrollBack && (
				<button
					className="absolute z-50 p-2 top-2 right-2  bg-[#fbb554] rounded-full shadow-md hover:bg-[#ffa256] text-white"
					onClick={() => scroll(-scrollAmount)}
				>
					{isHorizontal ? (
						<IoMdArrowDropleft size={28} />
					) : (
						<IoMdArrowDropup size={28} />
					)}
				</button>
			)}
			{canScrollForward && (
				<button
					className="absolute z-50 p-2 bottom-2 right-2  bg-[#fbb554] rounded-full shadow-md hover:bg-[#ffa256] text-white"
					onClick={() => scroll(scrollAmount)}
				>
					{isHorizontal ? (
						<IoMdArrowDropright size={28} />
					) : (
						<IoMdArrowDropdown size={28} />
					)}
				</button>
			)}
			<div className={` w-full h-full`}>{children}</div>
		</div>
	);
};

export default ScrollableWrapper;
